(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/prolong-game/assets/javascripts/prolong-game.js') >= 0) return;  svs.modules.push('/components/numbergames/prolong-game/assets/javascripts/prolong-game.js');

'use strict';

const {
  context: {
    ProlongProvider
  },
  components: {
    ProlongBottomSheet
  },
  analytics: {
    trackCloseProlongDialog
  }
} = svs.numbergames.prolong_game;
const ProlongGame = _ref => {
  let {
    wager,
    onOpenClose,
    trackingCategory,
    onSuccessCb,
    onDoneCb,
    onCancelCb,
    getAfterChangeReturnUrl,
    onboardingWidgetArea
  } = _ref;
  return React.createElement(ProlongProvider, {
    wager: wager,
    trackingCategory: trackingCategory,
    onSuccessCb: onSuccessCb,
    onDoneCb: onDoneCb,
    onCancelCb: onCancelCb,
    getAfterChangeReturnUrl: getAfterChangeReturnUrl,
    onboardingWidgetArea: onboardingWidgetArea
  }, React.createElement("div", {
    className: "prolong-game-container"
  }, React.createElement(ProlongBottomSheet, {
    behavior: "modal",
    isFixed: true,
    headerTitle: "F\xF6rl\xE4ng spel",
    onStateChange: newState => {
      if (newState.state === 'closed') {
        trackCloseProlongDialog(trackingCategory);
        onOpenClose({
          isOpen: false
        });
      }
    }
  })));
};
setGlobal('svs.numbergames.prolong_game.ProlongGame', ProlongGame);

 })(window);